<template>
	<PopupRouterViewDetail label="Work Order Supply Detail" @hideMethod="onHidden" :isShowCopyData="false">

		<!-- APP_DETAIL_HEADER -->

		<b-card header="Work Order Supply" class="mb-3">
			<b-row>
				<b-col cols="6">
					<app-input-combobox-autocomplete :options="workOrderProcesss" optionsLabel="workOrderProcessNumber"
						optionsKey="id" label-cols-lg="12" label="Work Order Process Number"
						id="fieldset-work-order-process" size="sm" :model.sync="model.workOrderProcessId"
						:selected="model.workOrderProcess != null ? model.workOrderProcess.workOrderProcessNumber : ''"
						@input="getWorkOrderProcesss" @change="onWorkOrderProcessChange" :isEditable="false" />
					<app-label label-cols-lg="12" size="sm" type="generatednumber" label="Work Order Supply Number"
						:model="model.workOrderSupplyNumber" />
					<app-input-datetimepicker id="fieldset-work-order-supply-date" label-cols-lg="12"
						label="WorkOrderSupplyDate" size="sm" :model.sync="model.workOrderSupplyDate"
						:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"
						@change="updateData" :isEditable="false" />
				</b-col>
				<b-col cols="6">
					<app-input-combobox-autocomplete :options="lines" optionsLabel="code" optionsKey="id"
						label-cols-lg="12" label="Line" id="fieldset-line" size="sm" :model.sync="model.lineId"
						:selected="model.line != null ? model.line.code : ''" @input="getLines" @change="updateData"
						:isEditable="false" :isSelectMethodExists="true" @onSelectMethod="setSelectedLine" />
					<app-input-textarea id="fieldset-remark" label-cols-lg="12" label="Remark" label-for="input-remark"
						size="sm" :model.sync="model.remark" @change="updateData" :isEditable="false" />
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12">

					<app-table-input-popup title="Work Order Supply" :bordered="true" :items="workOrderSupplyDetails"
						:fields="fieldsWorkOrderSupplyDetail" :busy="isDataLoading"
						:sort-by.sync="sortByWorkOrderSupplyDetail" :sort-desc.sync="sortDescWorkOrderSupplyDetail"
						small responsive @editButtonMethod="editRowDataWorkOrderSupplyDetail"
						@deleteButtonMethod="deleteRowDataWorkOrderSupplyDetail"
						@showPopupAddMethod="resetDataWorkOrderSupplyDetail()"
						@showPopupUploadMethod="showPopupUploadWorkOrderSupplyDetail()"
						@downloadMethod="downloadWorkOrderSupplyDetail()"
						@addFromClipboardMethod="addFromClipboardWorkOrderSupplyDetail()"
						@replaceFromClipboardMethod="replaceFromClipboardWorkOrderSupplyDetail()"
						:showActionButton="true" :showEditButton="false" :showDeleteButton="false"
						:showAddButton="false" :showAddFromClipboardButton="false"
						:showReplaceFromClipboardButton="false" :showUploadButton="false" :showDownloadButton="false"
						:isDownloadBusy="isDownloadWorkOrderSupplyDetail">
						<template #top-row v-if="isShowWorkOrderSupplyDetailFilter">
							<b-th></b-th>
							<b-th></b-th>
							<b-th stacked-heading="Part Number">
								<v-select append-to-body label="partNumber" :options="parts"
									:value="filterWorkOrderSupplyDetail.partId" :reduce="item => item.id"
									v-model="filterWorkOrderSupplyDetail.partId" @search="getParts"
									:filterable="true"></v-select>
							</b-th>
							<b-th stacked-heading="Material Part Number">
								<v-select append-to-body label="partNumber" :options="parts"
									:value="filterWorkOrderSupplyDetail.materialPartId" :reduce="item => item.id"
									v-model="filterWorkOrderSupplyDetail.materialPartId" @search="getParts"
									:filterable="true"></v-select>
							</b-th>
							<b-th stacked-heading="Work Order Process Detail">
								<v-select append-to-body label="part" :options="workOrderProcessDetails"
									:value="filterWorkOrderSupplyDetail.workOrderProcessDetailId"
									:reduce="item => item.id"
									v-model="filterWorkOrderSupplyDetail.workOrderProcessDetailId"
									@search="getWorkOrderProcessDetails" :filterable="true"></v-select>
							</b-th>
							<b-th stacked-heading="Bill Of Material Detail">
								<v-select append-to-body label="partNumber" :options="billOfMaterialDetails"
									:value="filterWorkOrderSupplyDetail.billOfMaterialDetailId"
									:reduce="item => item.id"
									v-model="filterWorkOrderSupplyDetail.billOfMaterialDetailId"
									@search="getBillOfMaterialDetails" :filterable="true"></v-select>
							</b-th>
							<b-th stacked-heading="Customer">
								<v-select append-to-body label="code" :options="customers"
									:value="filterWorkOrderSupplyDetail.customerId" :reduce="item => item.id"
									v-model="filterWorkOrderSupplyDetail.customerId" @search="getCustomers"
									:filterable="true"></v-select>
							</b-th>
							<b-th stacked-heading="Qty Plan">
								<b-form-input id="input-qty-plan-table" v-model="filterWorkOrderSupplyDetail.qtyPlan"
									size="sm"></b-form-input>
							</b-th>
							<b-th stacked-heading="Qty Consumption">
								<b-form-input id="input-qty-consumption-table"
									v-model="filterWorkOrderSupplyDetail.qtyConsumption" size="sm"></b-form-input>
							</b-th>
							<b-th stacked-heading="Qty Transit">
								<b-form-input id="input-qty-transit-table"
									v-model="filterWorkOrderSupplyDetail.qtyTransit" size="sm"></b-form-input>
							</b-th>
							<b-th stacked-heading="Qty Stock">
								<b-form-input id="input-qty-stock-table" v-model="filterWorkOrderSupplyDetail.qtyStock"
									size="sm"></b-form-input>
							</b-th>
							<b-th stacked-heading="Qty Supply">
								<b-form-input id="input-qty-supply-table"
									v-model="filterWorkOrderSupplyDetail.qtySupply" size="sm"></b-form-input>
							</b-th>
							<b-th stacked-heading="Uom">
								<v-select append-to-body label="code" :options="uoms"
									:value="filterWorkOrderSupplyDetail.uomId" :reduce="item => item.id"
									v-model="filterWorkOrderSupplyDetail.uomId" @search="getUoms"
									:filterable="true"></v-select>
							</b-th>
							<b-th stacked-heading="Remark">
								<b-form-input id="input-remark-table" v-model="filterWorkOrderSupplyDetail.remark"
									size="sm"></b-form-input>
							</b-th>

							<b-th></b-th>
						</template>
						<template v-slot:cell(no)="row">
							{{ ((row.index + 1) + (workOrderSupplyDetailPageSize * (currentWorkOrderSupplyDetailPage -
		1)))
							}}
						</template>
						<template v-slot:table-busys>
							<div class="text-center my-2">
								<b-spinner class="align-middle text-primary"></b-spinner>
								<strong class="ml-2">Loading...</strong>
							</div>
						</template>
						<template v-slot:cell(part)="row">
							<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id"
								:id="'input-work-order-supply-detail-part-' + row.index" label-cols-lg="12"
								label="Part Number - Name" size="sm" :model.sync="row.item.partId"
								@change="saveInputWorkOrderSupplyDetail(row.item)"
								:selected="row.item.part != null ? row.item.part.partNumber : ''" @input="getParts"
								:loading="isPartComboLoading" :isEditable="false" :nolabel="true" />
						</template>
						<template v-slot:cell(materialPart)="row">
							<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id"
								:id="'input-work-order-supply-detail-material-part-' + row.index" label-cols-lg="12"
								label="Material Part Number" size="sm" :model.sync="row.item.materialPartId"
								@change="saveInputWorkOrderSupplyDetail(row.item)"
								:selected="row.item.materialPart != null ? row.item.materialPart.partNumber : ''"
								@input="getParts" :loading="isPartComboLoading" :isEditable="false" :nolabel="true" />
						</template>
						<template v-slot:cell(workOrderProcessDetail)="row">
							<app-input-combobox-autocomplete :options="workOrderProcessDetails" optionsLabel="part"
								optionsKey="id"
								:id="'input-work-order-supply-detail-work-order-process-detail-' + row.index"
								label-cols-lg="12" label="Work Order Process Detail" size="sm"
								:model.sync="row.item.workOrderProcessDetailId"
								@change="saveInputWorkOrderSupplyDetail(row.item)"
								:selected="row.item.workOrderProcessDetail != null ? row.item.workOrderProcessDetail.part.partName : ''"
								@input="getWorkOrderProcessDetails" :loading="isWorkOrderProcessDetailComboLoading"
								:isEditable="false" :nolabel="true" />
						</template>
						<template v-slot:cell(partName)="row">
							<app-input-textbox label-cols-lg="12" size="sm" label="Part Name"
								:model="(row.item.materialPart != null) ? row.item.materialPart.partName : null"
								:nolabel="true" :isEditable="false" />
						</template>
						<template v-slot:cell(billOfMaterialDetail)="row">
							<app-input-combobox-autocomplete :options="billOfMaterialDetails" optionsLabel="partNumber"
								optionsKey="id"
								:id="'input-work-order-supply-detail-bill-of-material-detail-' + row.index"
								label-cols-lg="12" label="Bill Of Material Detail" size="sm"
								:model.sync="row.item.billOfMaterialDetailId"
								@change="saveInputWorkOrderSupplyDetail(row.item)"
								:selected="row.item.billOfMaterialDetail != null ? row.item.billOfMaterialDetail.partNumber : ''"
								@input="getBillOfMaterialDetails" :loading="isBillOfMaterialDetailComboLoading"
								:isEditable="false" :nolabel="true" />
						</template>
						<template v-slot:cell(customer)="row">
							<app-input-combobox-autocomplete :options="customers" optionsLabel="code" optionsKey="id"
								:id="'input-work-order-supply-detail-customer-' + row.index" label-cols-lg="12"
								label="Customer" size="sm" :model.sync="row.item.customerId"
								@change="saveInputWorkOrderSupplyDetail(row.item)"
								:selected="row.item.customer != null ? row.item.customer.code : ''"
								@input="getCustomers" :loading="isCustomerComboLoading" :isEditable="false"
								:nolabel="true" />
						</template>
						<template v-slot:cell(qtyPlan)="row">
							<app-input-textbox :id="'input-work-order-supply-detail-qty-plan-' + row.index"
								label-cols-lg="12" label="Qty Plan" size="sm" :model.sync="row.item.qtyPlan"
								@change="saveInputWorkOrderSupplyDetail(row.item)" :isEditable="false"
								:nolabel="true" />
						</template>
						<template v-slot:cell(qtyConsumption)="row">
							<app-input-textbox :id="'input-work-order-supply-detail-qty-consumption-' + row.index"
								label-cols-lg="12" label="Qty Consumption" size="sm"
								:model.sync="row.item.qtyConsumption" @change="saveInputWorkOrderSupplyDetail(row.item)"
								:isEditable="false" :nolabel="true" />
						</template>
						<template v-slot:cell(qtyTransit)="row">
							<app-input-textbox :id="'input-work-order-supply-detail-qty-transit-' + row.index"
								label-cols-lg="12" label="Qty Transit" size="sm" :model.sync="row.item.qtyTransit"
								@change="saveInputWorkOrderSupplyDetail(row.item)" :isEditable="false"
								:nolabel="true" />
						</template>
						<template v-slot:cell(qtyStock)="row">
							<app-input-textbox :id="'input-work-order-supply-detail-qty-stock-' + row.index"
								label-cols-lg="12" label="Qty Stock" size="sm" :model.sync="row.item.qtyStock"
								@change="saveInputWorkOrderSupplyDetail(row.item)" :isEditable="false"
								:nolabel="true" />
						</template>
						<template v-slot:cell(qtySupply)="row">
							<app-input-textbox :id="'input-work-order-supply-detail-qty-supply-' + row.index"
								label-cols-lg="12" label="Qty Supply" size="sm" :model.sync="row.item.qtySupply"
								@change="saveInputWorkOrderSupplyDetail(row.item)" :isEditable="false"
								:nolabel="true" />
						</template>
						<template v-slot:cell(uom)="row">
							<app-input-combobox-autocomplete :options="uoms" optionsLabel="code" optionsKey="id"
								:id="'input-work-order-supply-detail-uom-' + row.index" label-cols-lg="12" label="Uom"
								size="sm" :model.sync="row.item.uomId"
								@change="saveInputWorkOrderSupplyDetail(row.item)"
								:selected="row.item.uom != null ? row.item.uom.code : ''" @input="getUoms"
								:loading="isUomComboLoading" :isEditable="false" :nolabel="true" />
						</template>
						<template v-slot:cell(remark)="row">
							<app-input-textarea :id="'input-work-order-supply-detail-remark-' + row.index"
								label-cols-lg="12" label="Remark" size="sm" :model.sync="row.item.remark"
								@change="saveInputWorkOrderSupplyDetail(row.item)" :isEditable="false"
								:nolabel="true" />
						</template>

						<template v-slot:form-add-detail>
							<WorkOrderSupplyDetailInput :openPopup="isShowPopupWorkOrderSupplyDetail"
								:modelId="workOrderSupplyDetailId" @resetMethod="resetModal"
								@addButtonMethod="addRowDataWorkOrderSupplyDetail" />
						</template>
						<template v-slot:upload-detail>
							<WorkOrderSupplyDetailUpload :openPopup="isShowPopupUploadWorkOrderSupplyDetail"
								@resetMethod="resetModal" @uploadButtonMethod="uploadDataWorkOrderSupplyDetail"
								:parentId="modelId" />
						</template>
						<template #row-details="row">
							<b-card>
								<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber"
									optionsKey="id" :id="'input-work-order-supply-detail-material-part-' + row.index"
									label-cols-lg="12" label="Material Part Number" size="sm"
									:model.sync="row.item.materialPartId"
									@change="saveInputWorkOrderSupplyDetail(row.item)"
									:selected="row.item.materialPart != null ? row.item.materialPart.partNumber : ''"
									@input="getParts" :loading="isPartComboLoading" :isUpdatable="false"
									:isEditable="false" />
								<app-input-combobox-autocomplete :options="workOrderProcessDetails" optionsLabel="part"
									optionsKey="id"
									:id="'input-work-order-supply-detail-work-order-process-detail-' + row.index"
									label-cols-lg="12" label="Work Order Process Detail" size="sm"
									:model.sync="row.item.workOrderProcessDetailId"
									@change="saveInputWorkOrderSupplyDetail(row.item)"
									:selected="row.item.workOrderProcessDetail != null ? row.item.workOrderProcessDetail.part : ''"
									@input="getWorkOrderProcessDetails" :loading="isWorkOrderProcessDetailComboLoading"
									:isUpdatable="false" :isEditable="false" />
								<app-label label-cols-lg="12" size="sm" label="Part Name"
									:model="(row.item.materialPart != null) ? row.item.materialPart.partName : null" />
								<app-input-combobox-autocomplete :options="billOfMaterialDetails"
									optionsLabel="partNumber" optionsKey="id"
									:id="'input-work-order-supply-detail-bill-of-material-detail-' + row.index"
									label-cols-lg="12" label="Bill Of Material Detail" size="sm"
									:model.sync="row.item.billOfMaterialDetailId"
									@change="saveInputWorkOrderSupplyDetail(row.item)"
									:selected="row.item.billOfMaterialDetail != null ? row.item.billOfMaterialDetail.partNumber : ''"
									@input="getBillOfMaterialDetails" :loading="isBillOfMaterialDetailComboLoading"
									:isUpdatable="false" :isEditable="false" />
								<app-input-combobox-autocomplete :options="customers" optionsLabel="code"
									optionsKey="id" :id="'input-work-order-supply-detail-customer-' + row.index"
									label-cols-lg="12" label="Customer" size="sm" :model.sync="row.item.customerId"
									@change="saveInputWorkOrderSupplyDetail(row.item)"
									:selected="row.item.customer != null ? row.item.customer.code : ''"
									@input="getCustomers" :loading="isCustomerComboLoading" :isUpdatable="false"
									:isEditable="false" />
								<app-input-textbox :id="'input-work-order-supply-detail-qty-plan-' + row.index"
									label-cols-lg="12" label="Qty Plan" size="sm" :model.sync="row.item.qtyPlan"
									@change="saveInputWorkOrderSupplyDetail(row.item)" :isUpdatable="false"
									:isEditable="false" />
								<app-input-textbox :id="'input-work-order-supply-detail-qty-consumption-' + row.index"
									label-cols-lg="12" label="Qty Consumption" size="sm"
									:model.sync="row.item.qtyConsumption"
									@change="saveInputWorkOrderSupplyDetail(row.item)" :isUpdatable="false"
									:isEditable="false" />
								<app-input-textbox :id="'input-work-order-supply-detail-qty-transit-' + row.index"
									label-cols-lg="12" label="Qty Transit" size="sm" :model.sync="row.item.qtyTransit"
									@change="saveInputWorkOrderSupplyDetail(row.item)" :isUpdatable="false"
									:isEditable="false" />
								<app-input-textbox :id="'input-work-order-supply-detail-qty-stock-' + row.index"
									label-cols-lg="12" label="Qty Stock" size="sm" :model.sync="row.item.qtyStock"
									@change="saveInputWorkOrderSupplyDetail(row.item)" :isUpdatable="false"
									:isEditable="false" />
								<app-input-textbox :id="'input-work-order-supply-detail-qty-supply-' + row.index"
									label-cols-lg="12" label="Qty Supply" size="sm" :model.sync="row.item.qtySupply"
									@change="saveInputWorkOrderSupplyDetail(row.item)" :isUpdatable="false"
									:isEditable="false" />
								<app-input-combobox-autocomplete :options="uoms" optionsLabel="code" optionsKey="id"
									:id="'input-work-order-supply-detail-uom-' + row.index" label-cols-lg="12"
									label="Uom" size="sm" :model.sync="row.item.uomId"
									@change="saveInputWorkOrderSupplyDetail(row.item)"
									:selected="row.item.uom != null ? row.item.uom.code : ''" @input="getUoms"
									:loading="isUomComboLoading" :isUpdatable="false" :isEditable="false" />
								<app-input-textarea :id="'input-work-order-supply-detail-remark-' + row.index"
									label-cols-lg="12" label="Remark" size="sm" :model.sync="row.item.remark"
									@change="saveInputWorkOrderSupplyDetail(row.item)" :isUpdatable="false"
									:isEditable="false" />
							</b-card>
						</template>

					</app-table-input-popup> </b-col>
			</b-row>
			<b-row>
				<b-col cols="12" lg="6">
				</b-col>

			</b-row>
		</b-card>

		<!-- END_APP_DETAIL_HEADER -->
		<template #modal-left-button>
			<b-button size="sm" class="btn-outline-success" @click="printWosList"><b-icon-printer class="mr-1" /> Print WOS List</b-button>
			<b-button size="sm" class="btn-outline-warning" @click="editData" v-if="checkStatus">Edit</b-button>
		</template>

		<PopupPDF :openPopup="isShowPopUpPdf" :pdfUrl="pdfUrl" @resetModalMethod="resetModal" label="Print WO List" />

		<b-overlay :show="isBusy" no-wrap>
		</b-overlay>
	</PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import WorkOrderSupply from '@/models/WorkOrderSupply/WorkOrderSupply';
import WorkOrderSupplyList from '@/models/WorkOrderSupply/WorkOrderSupplyList';
import WorkOrderSupplyFilter from '@/filters/WorkOrderSupply/WorkOrderSupplyFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import WorkOrderProcess from '@/models/WorkOrderProcess/WorkOrderProcess';
import WorkOrderProcessFilter from '@/filters/WorkOrderProcess/WorkOrderProcessFilter';
import AppLabel from '@/components/AppLabel';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import AppInputTextarea from '@/components/AppInputTextarea';
import Line from '@/models/Line/Line';
import LineFilter from '@/filters/Line/LineFilter';
import DocumentStatus from '@/models/DocumentStatus/DocumentStatus';
import DocumentStatusFilter from '@/filters/DocumentStatus/DocumentStatusFilter';
import WorkOrderSupplyDetail from '@/models/WorkOrderSupply/WorkOrderSupplyDetail';
import WorkOrderSupplyDetailFilter from '@/filters/WorkOrderSupply/WorkOrderSupplyDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import WorkOrderProcessDetail from '@/models/WorkOrderProcess/WorkOrderProcessDetail';
import WorkOrderProcessDetailFilter from '@/filters/WorkOrderProcess/WorkOrderProcessDetailFilter';
import BillOfMaterialDetail from '@/models/BillOfMaterial/BillOfMaterialDetail';
import BillOfMaterialDetailFilter from '@/filters/BillOfMaterial/BillOfMaterialDetailFilter';
import Customer from '@/models/Customer/Customer';
import CustomerFilter from '@/filters/Customer/CustomerFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import Uom from '@/models/Uom/Uom';
import UomFilter from '@/filters/Uom/UomFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import WorkOrderSupplyDetailInput from '@/views/WorkOrderSupply/WorkOrderSupplyDetailInput';
import WorkOrderSupplyDetailUpload from '@/views/WorkOrderSupply/WorkOrderSupplyDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
import PopupPDF from '@/components/PopupPDF';
export default {
	components: {
		AppInputComboboxAutocomplete,
		AppLabel,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		AppInputTextarea,
		AppInputTextbox,
		WorkOrderSupplyDetailInput, WorkOrderSupplyDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterViewDetail,
		PopupRouterView,
		PopupPDF,
	},
	mixins: [validationMixin],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage: {
			},
			datas: Array(),
			selectAll: false,
			sortBy: '',
			sortDesc: '',
			pagingOptions: [
				{ value: '10', text: '10', selected: true },
				{ value: '25', text: '25' },
				{ value: '50', text: '50' },
				{ value: '100', text: '100' },
			],
			fieldsWorkOrderSupplyDetail: [
				{ "frontActions": { "class": "th-actions", "label": "" } },
				{ "no": { "class": "th-number d-stack-none" } },
				{ "part": { "class": "th-part first-child", "label": "Part Number", key: 'part', sortable: false } },
				{ "materialPart": { "class": "th-material-part", "label": "Material Part Number", key: 'materialPart', sortable: false } },
				//{ "workOrderProcessDetail": { "class": "th-work-order-process-detail last-child", "label": "Work Order Process Detail", key: 'workOrderProcessDetail', sortable: false } },
				{ "partName": { "class": "th-part-name d-stack-none", "label": "Part Name", key: 'partName', sortable: false } },
				//{ "billOfMaterialDetail": { "class": "th-bill-of-material-detail d-stack-none", "label": "Bill Of Material Detail", key: 'billOfMaterialDetail', sortable: false } },
				{ "customer": { "class": "th-customer d-stack-none", "label": "Customer", key: 'customer', sortable: false } },
				{ "qtyPlan": { "class": "th-qty-plan d-stack-none", "label": "Qty Plan", key: 'qtyPlan', sortable: false } },
				{ "qtyConsumption": { "class": "th-qty-consumption d-stack-none", "label": "Qty Consumption", key: 'qtyConsumption', sortable: false } },
				{ "qtyTransit": { "class": "th-qty-transit d-stack-none", "label": "Qty Transit", key: 'qtyTransit', sortable: false } },
				{ "qtyStock": { "class": "th-qty-stock d-stack-none", "label": "Qty Stock", key: 'qtyStock', sortable: false } },
				{ "qtySupply": { "class": "th-qty-supply d-stack-none", "label": "Qty Supply", key: 'qtySupply', sortable: false } },
				{ "uom": { "class": "th-uom d-stack-none", "label": "Uom", key: 'uom', sortable: false } },
				{ "remark": { "class": "th-remark d-stack-none", "label": "Remark", key: 'remark', sortable: false } },
				{ "actions": { "class": "th-actions d-stack-show", "label": "" } }
			],
			busy: false,
			isBusy: false,
			isDataLoading: false,
			selected: '',
			pageSizeOptions: 10,
			pageIndex: 0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelWorkOrderSupplyDetail: {},
			isShowPopupWorkOrderSupplyDetail: false,
			isShowPopupUploadWorkOrderSupplyDetail: false,
			filterWorkOrderSupply: null,
			currentWorkOrderSupplyPage: 1,
			workOrderSupplyPageSize: 10,
			sortByWorkOrderSupply: '',
			sortDescWorkOrderSupply: '',
			filterWorkOrderSupplyDetail: null,
			currentWorkOrderSupplyDetailPage: 1,
			workOrderSupplyDetailPageSize: 10,
			sortByWorkOrderSupplyDetail: '',
			sortDescWorkOrderSupplyDetail: '',
			sortingByWorkOrderSupplyDetail: [],
			workOrderSupplyDetails: [],
			workOrderSupplyDetailId: '',
			totalWorkOrderSupplyDetailRow: 0,
			isShowWorkOrderSupplyDetailFilter: false,
			isDownloadWorkOrderSupplyDetail: false,
			parts: [],
			workOrderProcessDetails: [],
			billOfMaterialDetails: [],
			customers: [],
			uoms: [],
			workOrderProcesss: [],
			workOrderProcesss: [],
			isWorkOrderProcessComboLoading: false,
			lines: [],
			lines: [],
			isLineComboLoading: false,
			documentStatuss: [],
			documentStatuss: [],
			isDocumentStatusComboLoading: false,
			isShowPopupConfirmation: false,
			isDataCommited: false,
			mainRecordId: '',
			isWorkOrderProcessComboLoading: false,
			isLineComboLoading: false,
			isDocumentStatusComboLoading: false,
			isWorkOrderSupplyComboLoading: false,
			isPartComboLoading: false,
			isWorkOrderProcessDetailComboLoading: false,
			isBillOfMaterialDetailComboLoading: false,
			isCustomerComboLoading: false,
			isUomComboLoading: false,
			checkStatus: false,
			isShowPopUpPdf: false,
			pdfUrl: '',
		}
	},
	methods: {
		printWosList: async function () {
			try {
				this.isBusy = true;
				let result = await WorkOrderSupply.printWoList(this, this.model.workOrderSupplyNumber, this.model.id);
				if(result) {
					this.isShowPopUpPdf = true;
					this.pdfUrl = result.download;
				}
				this.isBusy = false;
			} catch(error) {
				this.isShowPopUpPdf = false;
				this.pdfUrl = '';
				this.isBusy = false;
			}
		},
		editData: function () {
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				this.isBusy = true;
				WorkOrderSupply.editRequest(this, id).then(result => {
					if (result != null) {
						if (result.id != null && result.id != "") {
							this.$router.push({ name: 'workordersupplyedit', params: { id: result.id } });
						}
					}
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		getWorkOrderSupply: async function (id) {
			this.isBusy = true;
			WorkOrderSupply.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();

				if (result.documentStatusId == "OPEN") {
					this.checkStatus = true;
				}

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadWorkOrderSupply = true;
			this.filterWorkOrderSupply.id = this.modelId;
			WorkOrderSupply.downloadDataDetail(this, this.filterWorkOrderSupply).then(result => {
				this.isDownloadWorkOrderSupply = false;
			}).catch(error => { this.isDownloadWorkOrderSupply = false; })
		},
		getWorkOrderSupplyDetails: async function (isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterWorkOrderSupplyDetail);
			if (this.modelId == null) return;
			filter.workOrderSupplyId = this.modelId;
			filter.draftMode = "0";
			if (this.sortByWorkOrderSupplyDetail != null) {
				this.sortingByWorkOrderSupplyDetail[this.sortByWorkOrderSupplyDetail] = this.sortDescWorkOrderSupplyDetail;
			}
			let currentPage = (this.currentWorkOrderSupplyDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalWorkOrderSupplyDetailRow + 1;
				let page = Math.ceil(totalData / this.workOrderSupplyDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.workOrderSupplyDetailPageSize = 0;
			// disable paging end
			WorkOrderSupplyDetail.getList(this, filter, this.sortingByWorkOrderSupplyDetail, currentPage, this.workOrderSupplyDetailPageSize).then(result => {
				this.currentWorkOrderSupplyDetailPage = currentPage + 1;
				this.workOrderSupplyDetails = result.data;
				this.totalWorkOrderSupplyDetailRow = result.dataCount;
			}).catch(error => { });
		},
		getWorkOrderSupplys: async function (input) {
			let filter = new WorkOrderSupplyFilter();
			if (input != undefined) {
				filter.WorkOrderSupplyDate = input;
			}
			this.isWorkOrderSupplyComboLoading = true;
			WorkOrderSupply.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.workOrderSupplys = result.data
					}
					this.isWorkOrderSupplyComboLoading = false;
				})
				.catch(error => { });
		},
		getWorkOrderSupplys: async function (input) {
			let filter = new WorkOrderSupplyFilter();
			if (input != undefined) {
				filter.workOrderSupplyDate = input;
			}
			this.isWorkOrderSupplyComboLoading = true;
			WorkOrderSupply.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.workOrderSupplys = result.data
					}
					this.isWorkOrderSupplyComboLoading = false;
				})
				.catch(error => { });
		},
		getParts: async function (input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.parts = result.data
					}
					this.isPartComboLoading = false;
				})
				.catch(error => { });
		},
		getWorkOrderProcessDetails: async function (input) {
			let filter = new WorkOrderProcessDetailFilter();
			if (input != undefined) {
				filter.part = input;
			}
			this.isWorkOrderProcessDetailComboLoading = true;
			WorkOrderProcessDetail.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.workOrderProcessDetails = result.data
					}
					this.isWorkOrderProcessDetailComboLoading = false;
				})
				.catch(error => { });
		},
		getBillOfMaterialDetails: async function (input) {
			let filter = new BillOfMaterialDetailFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isBillOfMaterialDetailComboLoading = true;
			BillOfMaterialDetail.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.billOfMaterialDetails = result.data
					}
					this.isBillOfMaterialDetailComboLoading = false;
				})
				.catch(error => { });
		},
		getCustomers: async function (input) {
			let filter = new CustomerFilter();
			if (input != undefined) {
				filter.code = input;
			}
			this.isCustomerComboLoading = true;
			Customer.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.customers = result.data
					}
					this.isCustomerComboLoading = false;
				})
				.catch(error => { });
		},
		getUoms: async function (input) {
			let filter = new UomFilter();
			if (input != undefined) {
				filter.code = input;
			}
			this.isUomComboLoading = true;
			Uom.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.uoms = result.data
					}
					this.isUomComboLoading = false;
				})
				.catch(error => { });
		},
		getWorkOrderProcesss: async function (input) {
			let filter = new WorkOrderProcessFilter();
			if (input != undefined) {
				filter.workOrderProcessNumber = input;
			}
			filter.fwDocStat = '0,1';
			filter.exactType.fwDocStat = '1';
			WorkOrderProcess.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.workOrderProcesss = result.data
					}
				})
				.catch(error => { });
		},
		setSelectedWorkOrderProcessExecuted(item) {
			let _this = this;
			if (item == undefined || item == null) {
				this.model.workOrderProcessId = null;
				this.model.workOrderProcess = null;
				this.isBusy = true;
				WorkOrderSupply.resetDocument(this, this.model.id).then(result => {
					this.getWorkOrderSupply(this.model.id).then(result => {
						this.getWorkOrderSupplyDetails();
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}).catch(error => { this.isBusy = false; });
			} else {
				this.model.workOrderProcessId = item.id;
				this.model.workOrderProcess = item;

				this.isBusy = true;
				WorkOrderSupply.copyFromDocument(this, 'workorderprocess', item.id, this.model.id).then(result => {
					this.getWorkOrderSupply(this.model.id).then(result => {
						this.getWorkOrderSupplyDetails();
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}).catch(error => { this.isBusy = false; });
			}
		},
		setSelectedWorkOrderProcess(item) {
			if (item) {
				var itemId = Number(item.id);
				if (this.model.workOrderProcessId == itemId) return;
			}

			if (this.workOrderSupplyDetails != null && this.workOrderSupplyDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap Work Order Supply akan me-reset form yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
					.then(value => {
						if (value) {
							this.setSelectedWorkOrderProcessExecuted(item);
						}
					})
					.catch(err => { })
			} else {
				this.setSelectedWorkOrderProcessExecuted(item);
			}
		},
		onWorkOrderProcessChange: async function () {
			let item = this.model.workOrderProcessId;
			let workOrderProcessObj = this.workOrderProcesss.filter(function (workOrderProcess) { return workOrderProcess.id == item; });
			this.model.workOrderProcess = workOrderProcessObj.length > 0 ? workOrderProcessObj[0] : null;
		},

		getLines: async function (input) {
			let filter = new LineFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Line.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.lines = result.data
					}
				})
				.catch(error => { });
		},
		setSelectedLine(item) {
			if (item == undefined || item == null) {
				this.model.lineId = null;
				this.model.line = null;
			} else {
				this.model.lineId = item.id;
				this.model.line = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getDocumentStatuss: async function (input) {
			let filter = new DocumentStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			DocumentStatus.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.documentStatuss = result.data
					}
				})
				.catch(error => { });
		},
		setSelectedDocumentStatus(item) {
			if (item == undefined || item == null) {
				this.model.documentStatusId = null;
				this.model.documentStatus = null;
			} else {
				this.model.documentStatusId = item.id;
				this.model.documentStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.workOrderSupplyInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch();
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					WorkOrderSupply.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'workordersupplyindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					WorkOrderSupply.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'workordersupplyindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					WorkOrderSupply.updateDataDetail(this, model, id)
						.catch((error) => {
							this.getWorkOrderSupply(id);
						});
				}
			});
		},
		onHidden() {
			this.getWorkOrderSupplys();
		},
		addRowDataWorkOrderSupplyDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.workOrderSupplyId = this.modelId;
					WorkOrderSupplyDetail.updateDataDetail(this, model, model.id)
						.then(result => {
							this.getWorkOrderSupplyDetails(true);
							this.isShowPopupWorkOrderSupplyDetail = false;
						})
				} else {
					model.workOrderSupplyId = this.modelId;
					WorkOrderSupplyDetail.createDataDetail(this, model)
						.then(result => {
							this.getWorkOrderSupplyDetails(true);
							this.isShowPopupWorkOrderSupplyDetail = false;
						})
				}
			}
		},
		async editRowDataWorkOrderSupplyDetail(id) {
			this.workOrderSupplyDetailId = id;
			this.isShowPopupWorkOrderSupplyDetail = true;
		},
		async deleteRowDataWorkOrderSupplyDetail(id) {
			WorkOrderSupplyDetail.deleteData(this, id).then(result => { this.getWorkOrderSupplyDetails(); });
		},
		async resetDataWorkOrderSupplyDetail() {
			this.workOrderSupplyDetailId = "";
			this.isShowPopupWorkOrderSupplyDetail = true;
		},
		async addDataWorkOrderSupplyDetail() {
			WorkOrderSupplyDetail.createData(this, { workOrderSupplyId: this.modelId })
				.then(result => {
					this.getWorkOrderSupplyDetails(true);
				})
		},
		async addFromClipboardWorkOrderSupplyDetail() {
			let materialParts = new Array();
			navigator.clipboard.readText().then(value => {
				if (value.match(/(?:\r\n|\r|\n)/g)) { value = value.replace(/(?:\r\n|\r|\n)/g, ','); }
				let values = value.split(",");
				values.forEach(item => {
					materialParts.push({ materialPart: item, workOrderSupplyId: this.modelId });
				});
				WorkOrderSupplyDetail.addFromClipboard(this, materialParts).then(result => { this.getWorkOrderSupplyDetails() });
			});
		},
		async replaceFromClipboardWorkOrderSupplyDetail() {
			let materialParts = new Array();
			navigator.clipboard.readText().then(value => {
				if (value.match(/(?:\r\n|\r|\n)/g)) { value = value.replace(/(?:\r\n|\r|\n)/g, ','); }
				let values = value.split(",");
				values.forEach(item => {
					materialParts.push({ materialPart: item, workOrderSupplyId: this.modelId });
				});
				WorkOrderSupplyDetail.replaceFromClipboard(this, materialParts).then(result => { this.getWorkOrderSupplyDetails() });
			});
		},
		showPopupUploadWorkOrderSupplyDetail() {
			if (this.workOrderSupplyDetails != null && this.workOrderSupplyDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap WorkOrderSupplyDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
					.then(value => {
						if (value) {
							this.isShowPopupUploadWorkOrderSupplyDetail = true;
						}
					})
					.catch(err => { })
			} else {
				this.isShowPopupUploadWorkOrderSupplyDetail = true;
			}
		},
		uploadDataWorkOrderSupplyDetail(modalEvent, newDatas) {
			this.isShowPopupUploadWorkOrderSupplyDetail = false;
		},
		downloadWorkOrderSupplyDetail(modalEvent) {
			this.isDownloadWorkOrderSupplyDetail = true;
			this.filterWorkOrderSupplyDetail.workOrderSupplyId = this.modelId;
			WorkOrderSupplyDetail.downloadDataDetail(this, this.filterWorkOrderSupplyDetail).then(result => {
				this.isDownloadWorkOrderSupplyDetail = false;
			}).catch(error => { this.isDownloadWorkOrderSupplyDetail = false; })
		},
		saveInputWorkOrderSupplyDetail(item) {
			if (this.workOrderSupplys != null && this.workOrderSupplys != undefined && this.workOrderSupplys.length > 0) {
				item.workOrderSupply = this.workOrderSupplys.find(q => q.id == item.workOrderSupplyId);
			}
			if (this.parts != null && this.parts != undefined && this.parts.length > 0) {
				item.part = this.parts.find(q => q.id == item.partId);
			}
			if (this.workOrderProcessDetails != null && this.workOrderProcessDetails != undefined && this.workOrderProcessDetails.length > 0) {
				item.workOrderProcessDetail = this.workOrderProcessDetails.find(q => q.id == item.workOrderProcessDetailId);
			}
			if (this.billOfMaterialDetails != null && this.billOfMaterialDetails != undefined && this.billOfMaterialDetails.length > 0) {
				item.billOfMaterialDetail = this.billOfMaterialDetails.find(q => q.id == item.billOfMaterialDetailId);
			}
			if (this.customers != null && this.customers != undefined && this.customers.length > 0) {
				item.customer = this.customers.find(q => q.id == item.customerId);
			}
			if (this.uoms != null && this.uoms != undefined && this.uoms.length > 0) {
				item.uom = this.uoms.find(q => q.id == item.uomId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					WorkOrderSupplyDetail.updateDataDetail(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopUpPdf = false;
			this.isShowPopupUploadWorkOrderSupplyDetail = false;
			this.isShowPopupWorkOrderSupplyDetail = false;
			if (modalType == 'WorkOrderSupplyDetail') {
				this.getWorkOrderSupplyDetails();
			}
			this.showPopupCopyData = false;
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				//this.isShowWorkOrderSupplyDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterWorkOrderSupply = new WorkOrderSupplyFilter();
		this.filterWorkOrderSupplyDetail = new WorkOrderSupplyDetailFilter();
		//this.getWorkOrderSupplys();
		//this.getParts();
		//this.getWorkOrderProcessDetails();
		//this.getBillOfMaterialDetails();
		//this.getCustomers();
		//this.getUoms();
		//this.getWorkOrderProcesss();
		//this.getLines();
		//this.getDocumentStatuss();
	},
	async mounted() {
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getWorkOrderSupply(id);
			} else {
				this.modelId = id;
				this.getWorkOrderSupply(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function () {
				if (this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch: {
		sortByWorkOrderSupplyDetail: {
			handler: function () {
				this.getWorkOrderSupplyDetails();
			}
		},
		sortDescWorkOrderSupplyDetail: {
			handler: function () {
				this.getWorkOrderSupplyDetails();
			}
		},
		currentWorkOrderSupplyDetailPage: {
			handler: function () {
				this.getWorkOrderSupplyDetails();
			}
		},
		workOrderSupplyDetailPageSize: {
			handler: function () {
				this.getWorkOrderSupplyDetails();
			}
		},
		filterWorkOrderSupplyDetail: {
			handler: function () {
				this.getWorkOrderSupplyDetails();
			},
			deep: true,
		},
	},
}
</script>
